// extracted by mini-css-extract-plugin
module.exports = {"note":"note-3OzU8","info":"info-1GzRZ","timelimit":"timelimit-3Lmid","restriction":"restriction-3OSxC"};